// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/theme/index.css'
import './assets/css/reset.css'
import './assets/css/style.css'
import './assets/css/color.css'
import 'babel-polyfill'

import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'
import Mock from './mock/mock'
import VueI18n from 'vue-i18n'
import VeeValidate,{Validator} from 'vee-validate';
import zh from 'vee-validate/dist/locale/zh_CN';//引入中文文件
import util from './common/util'
import {reqValidPhone} from './api/system-api';
import $ from 'jquery';


Vue.use(ElementUI)
// let mock = new MockAdapter(axios);
// Mock.init(mock);

window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false
Validator.addLocale(zh);


// 自定义验证规则验证邮箱号
Validator.extend('email', {
  messages: {
    zh_CN:field => field + '必须填写正确格式（长度50个字符以内）',
  },
  validate: value => {
    // return  /^[A-Za-z0-9d]+([-_.][A-Za-z0-9d]+)*@([A-Za-z0-9d]+[-.])+[A-Za-zd]{2,5}$/.test(value)
    return  value.length <= 50 && /^[A-Za-z0-9d]+([-_.][A-Za-z0-9d]+)*@([A-Za-z0-9d]+[-.])+[A-Za-zd]{2,5}$/.test(value)
  }
});

// 自定义验证密码规则
Validator.extend('password', {
  messages: {
    zh_CN:field => field + '为6-16位,字母和数字组合(区分大小写),不允许有空格!',
  },
  validate: value => {
    return  6<=value.length <= 16 && /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(value)
  }
});

// 自定义验证规则
Validator.extend('phoneNumber', {
  messages: {
    zh_CN:field => field + '不正确，请重新填写！',
  },
  validate: value => {
    var isPhone=false;
    var strArray=value.split('|');
    var phoneNumber=strArray[1];
    var countryCode=strArray[0];

    if(phoneNumber===""){
      return false;
    }

    $.ajax({
      url:reqValidPhone,
      type:'GET',
      async:false,
      data:{
        phoneNumber:phoneNumber,
        countryCode: countryCode,
      },
      timeout:2000,
      dataType:'json',
      success:function(data,textStatus,jqXHR){
        isPhone = data.data;
      },
      error:function(xhr,textStatus){
      },
    })
    return isPhone;
  }
});



// 自定义validate
const dictionary = {
  zh_CN: {
    messages: {
      required: ( field )=> "请输入" + field
    },
  }
};

Validator.updateDictionary(dictionary);



const config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'veefields',
  delay: 0,
  locale: 'zh_CN',
  dictionary: null,
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'blur',
  inject: true,
  validity: false,
  aria: true,
  i18n: null, // the vue-i18n plugin instance,
  // i18nRootKey: 'validations' // the nested key under which the validation messsages will be located
};



Vue.use(VueI18n)
Vue.use(VeeValidate,config);
Vue.use(VeeValidate);

Vue.filter("date_from_unix", unixTime => {
  if(unixTime)
    return util.formatDate.format(new Date((unixTime)), 'yyyy-MM-dd hh:mm:ss')
})
Vue.filter("date_from_unix_YearMonthDay", unixTime => {
    if(unixTime)
        return util.formatDate.format(new Date((unixTime)), 'yyyy-MM-dd')
})
Vue.filter("date_from_unix_Day", unixTime => {
  if(unixTime)
    return util.formatDate.format(new Date((unixTime)), 'dd')
})
Vue.filter("date_from_unix_YearMonth", unixTime => {
  if(unixTime)
    return util.formatDate.format(new Date((unixTime)), 'yyyy年MM月')
})
Vue.filter("date_from_unix_Minute", unixTime => {
  if(unixTime)
    return util.formatDate.format(new Date((unixTime)), 'hh:mm:ss')
})
Vue.filter("date_from_unix_MonthDay", unixTime => {
  if(unixTime)
    return util.formatDate.format(new Date((unixTime)), 'MM-dd')
})
Vue.filter("formatProjectStatus", pStatus => {
  if(pStatus === 'draft')
    return '草稿'
  else if(pStatus === 'approved_to_sale')
    return '已上架'
  else if(pStatus === 'rejected')
    return '驳回'
  else if(pStatus === 'approved')
    return '审核通过'
  else if(pStatus === 'sold_out')
    return '已下架'
  else if(pStatus === 'under_review')
    return '待审核'
  else
    return ''
})
Vue.filter("formatFinancingType", fType => {
  if(fType === 'equity')
    return '股权'
  else if(fType === 'claims')
    return '债权'
  else if(fType === 'sandwich')
    return '夹层'
  else if(fType === 'other')
    return '其他'
  else
    return ''
})
Vue.filter("formatLocationContinent", lContinent => {
  if(lContinent === 'the_belt_and_road')
    return '大中华区'
  else if(lContinent === 'Asia')
    return '亚洲'
  else if(lContinent === 'Europe')
    return '欧洲'
  else if(lContinent === 'America')
    return '美洲'
  else if(lContinent === 'Oceania')
    return '大洋洲'
  else
    return ''
})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
    store,
  template: '<App/>',
  components: {App},
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js